import { Component } from '@angular/core';
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { MileageRefoundDataViewModel } from 'src/app/receipt-long-op/view-models/mileage-refound-data.view-model';
import { firstValueFrom, Observable } from 'rxjs';
import { ExpandableComponent, LabelledTextBoxComponent, MessageResourceManager, NTSTranslatePipe } from '@nts/std';
import { ReceiptParamsViewModel } from 'src/app/receipt-long-op/view-models/receipt-params.view-model';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { NgIf } from '@angular/common';
import { BaseStepComponent } from '../base-step.component';
import { WeaSettingsDataDto } from 'src/app/create-expense-annotation-long-op/api-clients/dto/wea-settings-data.dto';
import { ManageMileageRefoundData } from 'src/app/wea-settings/domain-models/manage-mileage-refound-data';

@UntilDestroy()
@Component({
  selector: 'nts-mileage-refound-data-step',
  templateUrl: './mileage-refound-data-step.component.html',
  styleUrls: ['./mileage-refound-data-step.component.scss'],
  standalone: true,
  imports: [
    NTSTranslatePipe,
    SvgIconComponent,
    ExpandableComponent,
    LabelledTextBoxComponent,
    NgIf
  ]
})
export class MileageRefoundDataStepComponent extends BaseStepComponent<MileageRefoundDataViewModel> {

  parentViewModel: ReceiptParamsViewModel;

  untilDestroyed(): <U>(source: Observable<U>) => Observable<U> {
    return untilDestroyed(this);
  }

  get currentConfiguration(): WeaSettingsDataDto {
    return this.rootViewModel.params.expenseData.configuration;
  }

  get mileageRefoundDataConfiguration(): ManageMileageRefoundData {
    return this?.currentConfiguration?.manageMileageRefoundData;
  }

  async onViewModelLoaded() {
    this.receiptStepsService.stepLoading.next(true);

    const viewModel = this.receiptStepsService.getCurrentState() as MileageRefoundDataViewModel;


    const queryParams = await firstValueFrom(this.routeStateService.queryParams);
    let expenseAnnotationId = null;
    if (queryParams['expenseAnnotationId']) {
      expenseAnnotationId = parseInt(queryParams['expenseAnnotationId'], 10);
    }
    const remoteExpense = queryParams['remoteExpense'] === 'true';

    viewModel.initPresentationLogic(
      expenseAnnotationId,
      remoteExpense,
      this.rootViewModel.params.expenseSelection.expenseClassification.value,
      this.rootViewModel.params.expenseState,
      !(await this.isReadOnly(this.rootViewModel))
    );

    this.receiptStepsService.orchestratorViewModel.rootViewModelModified.pipe(untilDestroyed(this)).subscribe(() => {
      viewModel.validateStep();
    });

    viewModel.validateStep();

    this.inIframe = this.activatedRoute.snapshot.queryParams['iframe'] === 'true' || window.self !== window.top;


    this.receiptStepsService.stepLoading.next(false);

    this.viewModel = viewModel;

    //card #4532
    this.parentViewModel = viewModel.parent as ReceiptParamsViewModel;

    const customTitle = viewModel.newLabels().value[viewModel.currentExpenseClassificationType];
    const title = customTitle ??
      MessageResourceManager.Current.getMessage('ExpenseClassification_' + viewModel.expenseClassificationEnum[viewModel.currentExpenseClassificationType]);
    this.telemetryService.trackPageView({ name: title });
  };
}

